import { useNewCode } from '@calendly/feature-check-react'

import { CheckboxStatus } from './checkbox_status'
import { RadioStatus } from './radio_status'

export const Status = ({ params, onChange, useColumnLayout = false, useShortLabel = false }) => {
  const useSaFilterSettingsFlag = useNewCode('sa_filter_settings_mtg_pg', false)?.enabled

  return useSaFilterSettingsFlag
    ? (
      <CheckboxStatus
        params={params}
        onChange={onChange}
        useColumnLayout={useColumnLayout}
        useShortLabel={useShortLabel}
      />
    )
    : <RadioStatus params={params} onChange={onChange} />
}
